<template>
  <v-menu
    v-model="localMenu"
    :offsetY="true"
    transition="slide-x-reverse-transition"
    z-index="1010"
  >

    <v-card>
      <v-list>
        <v-list-item>
          <template v-slot:prepend>
            <v-list-item>
              <v-avatar color="indigo" size="36">
                <v-icon dark>account_circle</v-icon>
              </v-avatar>
            </v-list-item>
          </template>

          <v-list-item>
            <v-list-item-title>{{ user.firstName }} {{ user.lastName }} ({{ user.username }})</v-list-item-title>
            <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
          </v-list-item>
          <template v-slot:append>
            <v-list-item-action>
              <v-btn color="primary" :to="{name: 'profile-edit'}" variant="text" small>{{ $t("ui.action.Customize") }}</v-btn>
            </v-list-item-action>
          </template>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <div class="component-content">
        <LanguageSelector />
      </div>


      <v-divider></v-divider>

      <v-list>
        <v-list-item
          v-if="$hasPermission('a3m_core.DestinationManager')"
          :to="{name: 'organisation-countries-selection'}"
        >
          <v-list-item-title>{{ $t("ui.settings.country.CountrySelection") }}</v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="$hasPermission('a3m_core.DestinationManager')"
          :to="{name: 'organisation-cruise-lines'}"
        >
          <v-list-item-title>{{ $t("ui.cruise.CruiseLinesFavorites") }}</v-list-item-title>
        </v-list-item>

        <v-list-item
             v-if="$hasPermission('a3m_core.DestinationManager')"
            :to="{ name: 'filter-settings', params: { type: 'mytrip' } }"
        >
          <v-list-item-title>{{ $t("ui.myjourney_page.Page") }}</v-list-item-title>
        </v-list-item>

        <v-list-item
             v-if="$hasPermission('a3m_core.DestinationManager')"
            :to="{ name: 'filter-settings', params: { type: 'mycruise' } }"
        >
          <v-list-item-title>{{ $t("ui.myjourney_page.CruisePage") }}</v-list-item-title>
        </v-list-item>

        <v-list-item
              v-if="$hasPermission('a3m_core.DestinationManagerWidget')"
            :to="{name: 'widget-settings'}"
        >
          <v-list-item-title>{{ $t("ui.settings.Widget") }}</v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="$hasPermission('a3m_core.DestinationManagerCustomerContent')"
          :to="{name: 'customer-content-settings'}"
        >
          <v-list-item-title>{{ $t("ui.settings.IndividualContent") }}</v-list-item-title>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn
          :href="$t('ui.action.A3MImprintUrl')"
          target="_blank"
          variant="text"
          small
        >
          {{ $t("myjourney.Imprint") }}
        </v-btn>
        <span class="version-key ma-2">Version: {{ versionKey }}</span>
        <v-spacer></v-spacer>
        <v-btn color="primary" class="ma-2" size="small" variant="flat" @click="logout">{{ $t("ui.action.Logout") }}</v-btn>
      </v-card-actions>
    </v-card>

  </v-menu>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import LanguageSelector from '@/components/ui/LanguageSelector'

export default {
  name: 'ToolbarAvatar',
  components: {
    LanguageSelector
  },
  props : {
    menu: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localMenu: false
    };
  },
  computed: {
    ...mapState({
      user: state => state.authStore.user,
    }),
    ...mapGetters({
      versionKey: 'authStore/versionKey'
    })
  },
  methods: {
    ...mapActions({
      logout: 'authStore/logout'
    })
  },
  watch: {
    menu(newVal) {
      this.localMenu = newVal;
    },
    localMenu(newVal) {
      this.$emit('update:menu', newVal);
    }
  },
};
</script>

<style scoped>
  .version-key {
    font-size: 60%;
    color: gray;
  }

  .component-content {
    padding: 0.5rem 1rem;
  }

  :deep(.v-overlay__content) {
    position: fixed !important;
    top: auto !important;
    bottom: 20px !important;
    left: 320px !important;
  }
</style>